import axios from "axios";
import { useEffect, useState } from "react";
import { utcToZonedTime } from 'date-fns-tz';

interface backResponseEl {
  user: string;
  ruleTagName: string;
  temperatura?: number;
  attribute?: string;
  value?: number;
  threshold?: number;
  operator?: string;
  status?: string;
  contextName?: string;
  flanco: string;
  recvTime: string;
}

export interface AlertsResponse {
  user: string;
  ruleTagName: string;
  temperatura?: number;
  attribute?: string;
  value?: number;
  threshold?: number;
  operator?: string;
  status?: string;
  contextName?: string;
  flanco: string;
  recvTime: Date;
}

export type ServiceResponse = AlertsResponse[];

export function useGetAlerts(
  context: string,
  fecha_desde: string,
  fecha_hasta: string,
  page: number,
  pageSize: number,
  startLoading: Function,
  stopLoading: Function,
  hasLoadedData: Function,
  noLoadedData: Function
): ServiceResponse {
  const [alerts, setAlerts] = useState<ServiceResponse>([]);

  useEffect(() => {
    if (fecha_desde && fecha_hasta) {
      let didCancel = false;
      startLoading();
      axios
        .get(
          `${process.env.REACT_APP_API_HOST ?? ""
          }/api/v1/contexts/${context}/alerts`,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
            params: {
              fecha_desde: fecha_desde,
              fecha_hasta: fecha_hasta,
              skip: page * pageSize,
              limit: pageSize,
            },
          }
        )
        .then(async (response) => {
          let alertsResponse: ServiceResponse = [];
          response.data.forEach((alertBack: backResponseEl) => {
            // Filter out scheduledAdminAlert from the history view
            if (alertBack.ruleTagName !== 'scheduledAdminAlert') {
              const newAlertEl: AlertsResponse = {
                user: alertBack.user,
                ruleTagName: alertBack.ruleTagName,
                temperatura: alertBack.temperatura,
                attribute: alertBack.attribute,
                value: alertBack.value,
                threshold: alertBack.threshold,
                operator: alertBack.operator,
                status: alertBack.status,
                contextName: alertBack.contextName,
                flanco: alertBack.flanco,
                recvTime: new Date(alertBack.recvTime),
              };
              alertsResponse.push(newAlertEl);
            }
          });

          if (alertsResponse.length > 0) {
            setAlerts(alertsResponse);
            hasLoadedData();
          } else {
            noLoadedData();
          }
        })
        .catch(function (error) {
          console.log("error", error);
          noLoadedData();
        })
        .finally(() => {
          stopLoading();
        });
      return () => {
        didCancel = true;
      };
    }
  }, [context, fecha_desde, fecha_hasta, page, pageSize]);
  return alerts;
}
